import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import data1 from "../../Data/clinicalExamination/clinicalExaminationData.json";

export default function ClinicalExamination() {
  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Диспансеризация населения
      </h1>

      <h3 className="about-nii__title antiCorruption__title">
        В связи с отсутствием прикрепленного населения в ГБУ СО "УрНИИДВиИ"
        работа по диспансеризации населения не проводится.
      </h3>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Диспансеризацию вы можете пройти в поликлинике по месту жительства
        </h3>
        <Accordion data={data1} />
      </div>
    </section>
  );
}
